"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = _interopRequireDefault(require("react-dnd-html5-backend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Body =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Body, _React$Component);

  function Body(props) {
    var _this;

    _classCallCheck(this, Body);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Body).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onMoveRow", function (initialRowIndex, finalRowIndex) {
      if (Number.isInteger(initialRowIndex)) {
        var rowsArray = _toConsumableArray(_this.state.children);

        var rowsMoved = rowsArray.splice(initialRowIndex, 1)[0];
        var firstRows = rowsArray.splice(0, finalRowIndex);

        _this.setState({
          children: [].concat(_toConsumableArray(firstRows), [rowsMoved], _toConsumableArray(rowsArray))
        }, function () {
          _this.props.onMoveRow(initialRowIndex, finalRowIndex);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "processChildren", function (children) {
      return _react.default.Children.toArray(children).filter(function (child) {
        return !!child;
      }).map(function (child, index) {
        return _react.default.cloneElement(child, {
          id: child.props.id || (0, _unique.default)(),
          key: child.props.id,
          onDropRow: _this.props.onDropRow,
          onMoveRow: _this.onMoveRow
        });
      });
    });

    _this.state = {
      children: _this.processChildren(props.children)
    };
    return _this;
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          draggable = _this$props.draggable,
          children = _this$props.children;
      return draggable ? _react.default.createElement(_reactDnd.DragDropContextProvider, {
        backend: _reactDndHtml5Backend.default
      }, _react.default.createElement("tbody", {
        className: "co-table__body"
      }, _react.default.Children.map(this.state.children, function (child, index) {
        return _react.default.cloneElement(child, {
          index: index
        });
      }))) : _react.default.createElement("tbody", {
        className: "co-table__body"
      }, children);
    }
  }]);

  return Body;
}(_react.default.Component);

Body.displayName = 'Table.Body';
Body.propTypes = {
  children: _propTypes.any,
  onMoveRow: _propTypes.func,
  onDropRow: _propTypes.func,

  /** Function to generate rows. It receives the array from prop @@data@@ as parameter. @@For virtualized table only@@ */
  renderRow: _propTypes.func,

  /** {array} Required if @@renderRow@@ is defined. Array with body rows data. To be used with renderRow. @@For virtualized table only@@ */
  data: (0, _airbnbPropTypes.requiredBy)('renderRow', _propTypes.array)
};
var _default = Body;
exports.default = _default;
Body.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMoveRow",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "initialRowIndex",
      "type": null
    }, {
      "name": "finalRowIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "processChildren",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Table.Body",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "onMoveRow": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDropRow": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "renderRow": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to generate rows. It receives the array from prop @@data@@ as parameter. @@For virtualized table only@@"
    },
    "data": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('renderRow', array)"
      },
      "required": false,
      "description": "{array} Required if @@renderRow@@ is defined. Array with body rows data. To be used with renderRow. @@For virtualized table only@@"
    }
  }
};